import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Auth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, User, GoogleAuthProvider, signInWithPopup, OAuthProvider, sendPasswordResetEmail } from 'firebase/auth';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private auth: Auth;
  user$: Observable<User | null>;

  constructor(private router: Router) {
    this.auth = environment.auth;
    this.user$ = new Observable(subscriber => {
      onAuthStateChanged(this.auth, (user) => {
        subscriber.next(user); // Observa o estado do utilizador
      });
    });
  }

  // Método de login
  login(email: string, password: string): Promise<any> {
    return signInWithEmailAndPassword(this.auth, email, password)
      .then((result) => {
        // console.log('Login bem sucedido', result.user.email);
        this.router.navigate(['/webapp']);
        return result;
      })
  }

  loginWithGoogle(): Promise<any> {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account' // força escolher conta
    });

    // opcional: pedir scopes extra
    provider.addScope('email');
    provider.addScope('profile');

    return signInWithPopup(this.auth, provider)
      .then(result => {
        this.router.navigate(['/webapp']); // redireciona
        return result;
      })
      .catch(error => {
        console.error('Erro no login com Google:', error);
        throw error;
      });
  }

  // Login com Apple
  loginWithApple(): Promise<any | null> {
    const provider = new OAuthProvider('apple.com');

    provider.addScope('email');
    provider.addScope('name');

    return signInWithPopup(this.auth, provider)
      .then(result => {
        this.router.navigate(['/webapp']); // redireciona
        return result;
      })
      .catch(error => {
        if (error.code === 'auth/user-cancelled') {
          return null;
        }
        console.error('Erro no login com Apple:', error);
        throw error;
      });
  }


  // Método para recuperar a password
  resetPassword(email: string): Promise<void> {
    return sendPasswordResetEmail(this.auth, email)
      .then(() => {
        console.log('Email de recuperação enviado');
      })
      .catch((error) => {
        console.log('Erro ao enviar o email de recuperação:', error);
        throw error;
      });
  }

  // Método de registo
  register(email: string, password: string): Promise<any> {
    return createUserWithEmailAndPassword(this.auth, email, password)
      .then((result) => {
        console.log('Registo bem sucedido', result.user.email);
        this.router.navigate(['/login']);
        return result;
      })
  }

  // Método de logout
  logout(): Promise<void> {
    return signOut(this.auth).then(() => {
      this.router.navigate(['/login']);
    });
  }

  // Método para obter o utilizador autenticado
  getUser(): Observable<User | null> {
    return this.user$;
  }

  // Método para verificar se o utilizador está autenticado
  isAuthenticated(): Observable<boolean> {
    return new Observable(observer => {
      this.user$.subscribe(user => {
        observer.next(!!user); // Retorna true se o utilizador estiver autenticado
        observer.complete();
      });
    });
  }
}